function convertS3ToHttps(s3Url) {
  const parts = s3Url.replace("s3://", "").split("/");
  const bucketName = parts[0];
  const objectKey = parts.slice(1).join("/");

  return `https://${bucketName}.s3.us-west-2.amazonaws.com/${objectKey}`;
}

function convertToValidHttps(Url) {
  if (Url.startsWith("s3://")) {
    return convertS3ToHttps(Url);
  }
  return Url;
}

export default convertToValidHttps;
